import { gsap } from 'gsap';

export default function LandingLoader(timing){
  let target = $('*[data-barba-introductionscreen]');

  if(target){
    //gsap.set(target, {autoAlpha: 1});

  }
  this.init = function(){
    if(target){
      $('#global').css('visibility', 'visible');
        console.log("=================>",target);
      let fade = gsap.timeline( {
        onComplete: function(){

          $(target).remove();
          
        }
      });
   
    
    fade.to('#introduction-screen',
    {
        onStart:()=>{
          window.appEvent.trigger('app:transitionGlobal:end');
          
        },
        autoAlpha:0,
        duration:.65,
        ease:'circ.out',
        onComplete:()=>{
        }
        
    },'shadowAnimation');
  
   

 

    }
    else{
      return false;
    }
  }
  
}
